export const evaluation = {
    labels: {
        pending_analysis: "Análises Pendentes",
        concluded_analysis: "Análises Concluídas",
        started_analysis: "Análises Iniciadas",
        in_progress: "Andamento",
        started: "Iniciada",
        pending: "Pendente",
        concluded: "Finalizado",
        canceled: "Cancelado",
        all: "Exibir Tudo",
        period: "Período",
        start: "Início",
        start_forecast: "Previsão de Início",
        termination: "Previsão de término",
    },
    modal: {
        titles: {
            add_analysis: "Adicionar Análise",
            add_company: "Adicionar Empresa",
            add_evaluation: "Adicionar Avaliação",
            start_evaluation: "Iniciar Avaliação",
            cancel_evaluation: "Cancelar Avaliação",
            finish_evaluation: "Finalizar Avaliação",
        },
        messages: {
            add_analysis: "Deseja adicionar uma <strong>análise</strong> na avaliação?",
            add_company: "Deseja adicionar a empresa<br><strong>{concat}</strong><br>na avaliação?",
            add_employee: "Deseja adicionar o funcionário<br><strong>{concat}</strong><br>na avaliação?",
            add_evaluation: "Você deseja adicionar uma nova Avaliação?",
            start_evaluation: "Você deseja <strong>INICIAR</strong> a Avaliação?<br>Essa operação não poderá ser desfeita!",
            cancel_evaluation: "Você deseja <strong>CANCELAR</strong> a Avaliação?<br>Essa operação não poderá ser desfeita!",
            finish_evaluation: "Você deseja <strong>FINALIZAR</strong> a Avaliação?<br>Essa operação não poderá ser desfeita!",
        },
    },
    texts: {
        empty_evaluation: "Não há avaliações ativas para serem exibidas."
    },
};
